import * as React from "react"

const SvgStairs = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 19.857a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713q0-.424.288-.712A.97.97 0 0 1 3 17.857h5v-5a.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288h5v-5a.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288h6q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287h-5v5a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287h-5v5a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287z" />
  </svg>
)
export default SvgStairs
